module.exports = __webpack_public_path__ + "img/purchase4.838238c9.png";